import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		fill="none"
		viewBox="0 0 14 14"
		{...props}
	>
		<path
			fill="var(--svg-color, currentColor)"
			fillRule="evenodd"
			d="M11.04 3.502a5.749 5.749 0 1 0-1.593 6.652l3.7 3.7a.5.5 0 1 0 .707-.707l-3.7-3.7a5.75 5.75 0 0 0 .887-5.945M3.894 1.38a4.749 4.749 0 1 1 3.714 8.74 4.749 4.749 0 0 1-3.714-8.74"
			clipRule="evenodd"
		/>
	</svg>
);

export { SvgComponent as SearchIcon };
